import {ComponentProps, useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronDownIcon, ChevronUpIcon, SearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useRecentFiltersWithSurvey} from "../hooks/use_recent_filters_with_survey";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {
    getFilterTextParts,
    getRecentFilterFilterText,
    getRecentFilterSearchUrlWithFilters,
    getSurveyFilterText,
    getSurveySearchUrlWithFilters
} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {}

/**
 * Component to display up to 5 recent filters from localStorage.
 * Card layout: search icon, filter text (city bold), Zatwierdź button.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersRegions = (props: IProps) => {
    const {className, style, ...rest} = props;

    const {recentFilters, latestQuery, shouldShow, surveyFormValues, shouldShowSurvey, currentFormValues} = useRecentFiltersWithSurvey();

    const hasSurvey = shouldShowSurvey && surveyFormValues;
    const totalCount = (hasSurvey ? 1 : 0) + recentFilters.length;
    const [isExpanded, setIsExpanded] = useState(false);
    const visibleCount = isExpanded ? totalCount : Math.min(2, totalCount);
    const showSurvey = hasSurvey && visibleCount >= 1;
    const recentCount = visibleCount - (showSurvey ? 1 : 0);
    const recentFiltersToShow = recentFilters.slice(0, recentCount);
    const showExpandButton = totalCount > 2;

    const hasAnyContent = (shouldShow && recentFilters.length > 0) || (shouldShowSurvey && surveyFormValues);

    if (!hasAnyContent) {
        return null;
    }

    return (
        <div className={cx(recentFiltersContainerStyle, className)} style={style} {...rest}>
            <Text variant="body_copy_1" className={recentFiltersTitleStyle}>
                Twoje ostatnie wyszukiwania
            </Text>

            {showSurvey && surveyFormValues && (
                <RecentFilterRegionCard
                    key="survey"
                    filterText={getSurveyFilterText(surveyFormValues)}
                    url={getSurveySearchUrlWithFilters({...recentFiltersLinkConfig, surveyFormValues, latestQuery})}
                    emptyFallback="Twoje preferencje"
                />
            )}

            {recentFiltersToShow.map((recentFilter, index) => (
                <RecentFilterRegionCard
                    key={`${recentFilter.timestamp}-${index}`}
                    filterText={getRecentFilterFilterText(recentFilter)}
                    url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
                />
            ))}

            {showExpandButton && (
                <Button
                    type="button"
                    variant="none_secondary"
                    size="x-small"
                    fullWidth
                    className={expandButtonStyle}
                    onClick={() => setIsExpanded((prev) => !prev)}
                    iconRight={isExpanded ? ChevronUpIcon : ChevronDownIcon}
                >
                    {isExpanded ? "Zwiń" : "Rozwiń"}
                </Button>
            )}
        </div>
    );
};

interface RecentFilterRegionCardProps {
    filterText: string;
    url: string;
    emptyFallback?: string;
}

const RecentFilterRegionCard = ({filterText, url, emptyFallback}: RecentFilterRegionCardProps) => {
    const displayText = filterText || emptyFallback || "";
    const {boldPart, rest} = getFilterTextParts(displayText);

    return (
        <div className={recentFilterCardStyle}>
            <SearchIcon size="1.6" wrapperSize="1.6" className={searchIconStyle} />

            <div className={recentFilterCardContentStyle}>
                <Text variant="info_txt_1" className={recentFilterTextStyle} as="span">
                    {boldPart ? (
                        <>
                            <Text as="span" variant="info_txt_1" strong>
                                {boldPart}
                            </Text>
                            {rest}
                        </>
                    ) : (
                        displayText
                    )}
                </Text>
            </div>

            <Button href={url} variant="highlight_primary" size="small" className={confirmButtonStyle}>
                Zatwierdź
            </Button>
        </div>
    );
};

const recentFiltersContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});

const recentFiltersTitleStyle = css({
    mb: 0.5
});

const recentFilterCardStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    minHeight: "32px",
    px: 1.5,
    py: 0.5,
    backgroundColor: "var(--colors-background-100)",
    border: "1px solid var(--colors-gray-600)",
    borderRadius: "16px"
});

const searchIconStyle = css({
    flexShrink: 0
});

const recentFilterCardContentStyle = css({
    flex: 1,
    minWidth: 0
});

const recentFilterTextStyle = css({
    display: "block",
    color: "var(--colors-gray-800)"
});

const confirmButtonStyle = css({
    flexShrink: 0,
    textTransform: "uppercase"
});

const expandButtonStyle = css({
    justifyContent: "center",
    mt: 1,
    textTransform: "uppercase",
    padding: 0,
    height: "40px"
});
import {ComponentProps, useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronDownIcon, ChevronUpIcon, SearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useRecentFiltersWithSurvey} from "../hooks/use_recent_filters_with_survey";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {
    getFilterTextParts,
    getRecentFilterFilterText,
    getRecentFilterSearchUrlWithFilters,
    getSurveyFilterText,
    getSurveySearchUrlWithFilters
} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {}

/**
 * Component to display up to 5 recent filters from localStorage.
 * Card layout: search icon, filter text (city bold), Zatwierdź button.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersRegions = (props: IProps) => {
    const {className, style, ...rest} = props;

    const {recentFilters, latestQuery, shouldShow, surveyFormValues, shouldShowSurvey, currentFormValues} = useRecentFiltersWithSurvey();

    const hasSurvey = shouldShowSurvey && surveyFormValues;
    const totalCount = (hasSurvey ? 1 : 0) + recentFilters.length;
    const [isExpanded, setIsExpanded] = useState(false);
    const visibleCount = isExpanded ? totalCount : Math.min(2, totalCount);
    const showSurvey = hasSurvey && visibleCount >= 1;
    const recentCount = visibleCount - (showSurvey ? 1 : 0);
    const recentFiltersToShow = recentFilters.slice(0, recentCount);
    const showExpandButton = totalCount > 2;

    const hasAnyContent = (shouldShow && recentFilters.length > 0) || (shouldShowSurvey && surveyFormValues);

    if (!hasAnyContent) {
        return null;
    }

    return (
        <div className={cx(recentFiltersContainerStyle, className)} style={style} {...rest}>
            <Text variant="body_copy_1" className={recentFiltersTitleStyle}>
                Twoje ostatnie wyszukiwania
            </Text>

            {showSurvey && surveyFormValues && (
                <RecentFilterRegionCard
                    key="survey"
                    filterText={getSurveyFilterText(surveyFormValues)}
                    url={getSurveySearchUrlWithFilters({...recentFiltersLinkConfig, surveyFormValues, latestQuery})}
                    emptyFallback="Twoje preferencje"
                />
            )}

            {recentFiltersToShow.map((recentFilter, index) => (
                <RecentFilterRegionCard
                    key={`${recentFilter.timestamp}-${index}`}
                    filterText={getRecentFilterFilterText(recentFilter)}
                    url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
                />
            ))}

            {showExpandButton && (
                <Button
                    type="button"
                    variant="none_secondary"
                    size="x-small"
                    fullWidth
                    className={expandButtonStyle}
                    onClick={() => setIsExpanded((prev) => !prev)}
                    iconRight={isExpanded ? ChevronUpIcon : ChevronDownIcon}
                >
                    {isExpanded ? "Zwiń" : "Rozwiń"}
                </Button>
            )}
        </div>
    );
};

interface RecentFilterRegionCardProps {
    filterText: string;
    url: string;
    emptyFallback?: string;
}

const RecentFilterRegionCard = ({filterText, url, emptyFallback}: RecentFilterRegionCardProps) => {
    const displayText = filterText || emptyFallback || "";
    const {boldPart, rest} = getFilterTextParts(displayText);

    return (
        <div className={recentFilterCardStyle}>
            <SearchIcon size="1.6" wrapperSize="1.6" className={searchIconStyle} />

            <div className={recentFilterCardContentStyle}>
                <Text variant="info_txt_1" className={recentFilterTextStyle} as="span">
                    {boldPart ? (
                        <>
                            <Text as="span" variant="info_txt_1" strong>
                                {boldPart}
                            </Text>
                            {rest}
                        </>
                    ) : (
                        displayText
                    )}
                </Text>
            </div>

            <Button href={url} variant="highlight_primary" size="small" className={confirmButtonStyle}>
                Zatwierdź
            </Button>
        </div>
    );
};

const recentFiltersContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});

const recentFiltersTitleStyle = css({
    mb: 0.5
});

const recentFilterCardStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    minHeight: "32px",
    px: 1.5,
    py: 0.5,
    backgroundColor: "var(--colors-background-100)",
    border: "1px solid var(--colors-gray-600)",
    borderRadius: "16px"
});

const searchIconStyle = css({
    flexShrink: 0
});

const recentFilterCardContentStyle = css({
    flex: 1,
    minWidth: 0
});

const recentFilterTextStyle = css({
    display: "block",
    color: "var(--colors-gray-800)"
});

const confirmButtonStyle = css({
    flexShrink: 0,
    textTransform: "uppercase"
});

const expandButtonStyle = css({
    justifyContent: "center",
    mt: 1,
    textTransform: "uppercase",
    padding: 0,
    height: "40px"
});
